import { AlphaUBoxOutlineIcon } from './AlphaUBoxOutlineIcon';

/**
 * author: Contributors
 * id CAA94F37-3C12-4A17-A0CF-F093E39F5463
 * name alpha-u-box-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-u-box-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetUBoxOutlineIcon = AlphaUBoxOutlineIcon;
export default AlphabetUBoxOutlineIcon